import { Redirect, Route, Switch } from "react-router-dom";
import { Flow } from "../../../../../shared/components/Flow";
import { StepAbout } from "./StepAbout";
import { StepHowItWorks } from "./StepHowItWorks";
import { StepCertify } from "./StepCertify";
import { StepPaymentMethod } from "./StepPaymentMethod";
import { usePlanEnrollments } from "../../../../../query/benefits/usePlanEnrollments";
import { WSQueries } from "../../../../../query/WSQuery";
import { getPGLIBenefitListItem } from "../../../components/customBenefits/PGLI/getPGLIBenefitListItem";
import { OnboardingStepStatus } from "../../../../Onboarding/types";
import { selectorAvailablePlanEnrollments } from "../../../selectors/selectorAvailablePlanEnrollments";
import { useGetNow } from "../../../../../shared/hooks/useGetNow";

export const EnrollPGLI: React.FC<{
  basePath: string;
  goBack(): void;
}> = props => {
  const { basePath, goBack } = props;

  const now = useGetNow();

  const qPlanEnrollments = usePlanEnrollments({
    filter: {
      planType: "WingspanProfessionalLiabilityAndGeneralLiabilityInsurance"
    },
    sort: "createdAt"
  });

  return (
    <WSQueries queries={{ qPlanEnrollments }}>
      {({ qPlanEnrollmentsData }) => {
        const planEnrollment = selectorAvailablePlanEnrollments(
          qPlanEnrollmentsData,
          now
        ).find(Boolean);

        const isCompleted =
          planEnrollment?.status === "Active" ||
          planEnrollment?.status === "Terminated";
        const isPending = planEnrollment?.status === "Pending";

        const status: OnboardingStepStatus = isCompleted
          ? "Complete"
          : isPending
          ? "Pending"
          : "None";

        return (
          <Switch>
            <Route
              path={basePath}
              render={props => (
                <Flow
                  title="Insurance enrollment"
                  basePath={basePath}
                  hideNavigation={isCompleted || isPending}
                  steps={[
                    {
                      slug: "steps",
                      title: getPGLIBenefitListItem().name,
                      steps: [
                        {
                          slug: "intro",
                          title: "Intro",
                          component: StepAbout
                        },
                        {
                          slug: "how-it-works",
                          title: "How it works",
                          component: StepHowItWorks
                        },
                        {
                          slug: "payment-settings",
                          title: "Payment settings",
                          component: StepPaymentMethod
                        },
                        {
                          slug: "certify",
                          title: "Certify & enroll",
                          component: StepCertify
                        }
                      ],
                      status,
                      result: {
                        Complete: {
                          description: (
                            <>
                              Congrats! You’re now covered under Wingspan Master
                              Professional & General Liability Insurance.
                            </>
                          ),
                          title: "Your enrollment was successful!"
                        },
                        Pending: {
                          description: (
                            <>
                              Your enrollment is pending. Please check back
                              later.
                            </>
                          ),
                          title: "Your enrollment is pending"
                        }
                      }
                    }
                  ]}
                  onBack={goBack}
                  onNext={goBack}
                />
              )}
            />

            <Redirect from="*" to={basePath} />
          </Switch>
        );
      }}
    </WSQueries>
  );
};
